export default "images/jigou.png";